__turbopack_context__.v({
  "label": "InputRange-module__ozHinG__label",
});
